import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Sobre from '../views/Sobre.vue'
import Contato from '../views/Contato.vue'
import Login from '../views/Auth/Login.vue'
import Register from '../views/Auth/Register.vue'
import AdminHome from '../views/admin/Home.vue'
import Dashboard from '../views/admin/Dashboard.vue'
import Barbeiros from '../views/admin/Barbeiros.vue'
import Funcoes from '../views/admin/Funcoes.vue'
import Agenda from '../views/admin/Agenda.vue'
import Feriados from '../views/admin/Feriados.vue'
import Mensagem from '../views/admin/Mensagem.vue'
import Fotos from '../views/admin/Fotos.vue'
import Configuracoes from '../views/admin/Configuracoes.vue'
import Fidelidade from '../views/admin/Fidelidade.vue'
import Teste from '../views/admin/Teste.vue'



import store from '../store/index'
//import {auth} from '../../firebaseConfig'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
   
  },
  {
    path: '/sobre',
    name: 'Sobre',
    component: Sobre,
   

  },
  {
    path: '/contato',
    name: 'Contato',
    component: Contato,
   

  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
    
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  
  },
  {
    path: '/admin/home',
    name: 'AdminHome',
    component: AdminHome,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

     
    }
  },
  {
    path: '/admin/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    },
  },

  {
    path: '/admin/barbeiros',
    name: 'Barbeiros',
    component: Barbeiros,
    meta: {
      requiresAuth: true,
      requiresLevel: true,
    },
  },
  {
    path: '/admin/funcoes',
    name: 'Funcoes',
    component: Funcoes,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/agenda',
    name: 'Agenda',
    component: Agenda,
    meta: {
      requiresAuth: true
    },
  },
  {
    path: '/admin/mensagens',
    name: 'Mensagens',
    component: Mensagem,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/feriados',
    name: 'Feriados',
    component: Feriados,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/fotos',
    name: 'Fotos',
    component: Fotos,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/configuracoes',
    name: 'Configuracoes',
    component: Configuracoes,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/fidelidade',
    name: 'Fidelidade',
    component: Fidelidade,
    meta: {
      requiresAuth: true,
      requiresLevel: true,

    },
  },
  {
    path: '/admin/teste',
    name: 'Teste',
    component: Teste,
    meta: {
      requiresAuth: false,
      requiresLevel: false,

    },
  },
  /*
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true
    }
  },*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


router.beforeEach((to, from, next) => {
  //const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  //const adminOnly = to.matched.some(record => record.meta.adminOnly)
  //console.log(adminOnly)

  console.log("STORE", store.getters.userLevel);

  if (to.meta.requiresAuth) {
    
    //console.log(store.state.userProfile);
    //if(store.state.userProfile != null){
      
    if(store.getters.isUserAuth){
      //por padrão será acima de 2
      if (to.meta.requiresLevel){
        //console.log(store.state.authUser.permissoes);
       // console.log(store.state.authUser.userLvl);
       
       // BUG VUEX -> POR ALGUMA RAZÃO PRECISO ACESSAR STATE.{MODULO} ANTES DE USAR OS GETTERS...
        let permissao = store.state.authUser.permissoes[store.state.authUser.userLvl]

        //ISTO AQUI FUNCIONA SOMENTE SE CHAMAR O METHOD ACIMA...
        //console.log('BUSCADA',store.getters.userLevel);
        if(permissao > 2){
          console.log("mandando adiante pelo level")
          next()
          
        }
      }else{
      console.log("mandando adiante")
        next()
    }
    
   
      
    }else{
      console.log("redirecionando p login")
      next("/login")
      
    }

  }else{
    next()
  }

  
  

  
 
})
export default router
